/* eslint-disable react/prop-types */
import React from 'react';
import { RichText } from '../../core/RichText';
import useSurveyStyles from './useStyles';

export type Props = {
  text: string;
  element?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
};

const SurveyTitleV2: React.FC<Props> = ({ element = 'h1', text }) => {
  const { surveyTitle } = useSurveyStyles();
  return <RichText element={element} text={text} className={surveyTitle} />;
};

export default SurveyTitleV2;
